import React from 'react';
import styled from 'styled-components';
import Label from './label';

const Email = ({ email, className }) => (
  <div className={className}>
    <Label>E:</Label>
    <a href={`mailto:${email}`}>{email}</a>
  </div>
);

export default styled(Email)`
  display: flex;
`;
